export const getDarkCrosshairLine = () => ({
  visible: true,
  labelVisible: true,
  labelColor: '#ffffff',
  labelBackgroundColor: '#404349',
  lineColor: '#55595F',
})

export const getDarkCrosshairRect = () => ({
  visible: true,
  labelVisible: true,
  labelColor: '#ffffff',
  labelBackgroundColor: '#404349',
  rectColor: '#4B4F54',
})

export const getLightCrosshairLine = () => ({
  visible: true,
  labelVisible: true,
  labelColor: '#ffffff',
  labelBackgroundColor: '#21252C',
  lineColor: '#21252C',
})
export const getLightCrosshairRect = () => ({
  visible: true,
  labelVisible: true,
  labelColor: '#ffffff',
  labelBackgroundColor: '#364159',
  rectColor: '#D9DDE4',
})
